export default "__VITE_ASSET__Cx2E3wpQ__"